import PicturesApp from 'station/components/picture/PicturesApp'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitle } from 'utils/StationUtils'

const HydrometryPicturesApp = ({

}) => {
    const {
        hydrometricStation,
        hydrometricStations,
    } = useSelector(store => ({
        hydrometricStation: store.HydrometryReducer.hydrometricStation,
        hydrometricStations: store.HydrometryReducer.hydrometricStations,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.hydrometry,
        href: 'hydrometry',
    }, {
        title: getStationTitle(hydrometricStation),
        href: `station/hydrometry/${hydrometricStation?.id}`,
    }, {
        title: i18n.picturesAndDocuments,
        href: `station/hydrometry/${hydrometricStation?.id}/picture`,
    }], [hydrometricStation])

    return (
        <PicturesApp
            stations={hydrometricStations}
            station={hydrometricStation}
            stationType='hydrometry'
        />
    )
}

export default HydrometryPicturesApp